var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgString = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 3A.75.75 0 0 1 3 2.25h10a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V3.75h-3.5v8.5H10a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25v-8.5h-3.5V5a.75.75 0 0 1-1.5 0V3z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgString);
export default ForwardRef;